import { EventEmitter, OnInit } from '@angular/core';
import { Component, Input } from '@angular/core';
import { QuoteDetail } from '../../models/QuoteDetail';
import { faCirclePlus,faX,faPenToSquare } from '@fortawesome/free-solid-svg-icons';
import { _isNumberValue } from '@angular/cdk/coercion';
import { Output } from '@angular/core';
import { HttpService } from '../../services/HttpService';
import { MatDialog } from '@angular/material/dialog';
import { EditDetailsComponent } from '../popups/edit-details/edit-details.component';

@Component({
  selector: 'app-quote-detail',
  standalone: false,  
  templateUrl: './quote-detail.component.html',
  styleUrl: './quote-detail.component.css'
})

export class QuoteDetailComponent implements OnInit {
  @Input() CurrentDetail: QuoteDetail;
  @Input() IsDirectCustomer: boolean;
  @Output() DeleteLineEmitter: EventEmitter<QuoteDetail> = new EventEmitter();
  @Output() ReconfigureEmitter: EventEmitter<QuoteDetail> = new EventEmitter();
  faAdd = faCirclePlus;
  faX = faX;
  faEdit = faPenToSquare;

  public constructor(private http: HttpService, public matDialog: MatDialog) {
    //this.CurrentDetail.
  }

  ngOnInit() {

  }

  async SaveQuoteDetail() {
    this.http.SaveQuoteDetail(this.CurrentDetail);
  }



  GetBreakQtyString(qtyIndex: number):string {
    var QtyMessage = "";
    if (qtyIndex == 0 && this.CurrentDetail.BreakQty1 > 0) {
      QtyMessage = this.CurrentDetail.BreakQty1 + (this.CurrentDetail.BreakQty2 > 0 ? "-" + (this.CurrentDetail.BreakQty2 - 1).toString() : "+");
    } else if (qtyIndex == 1 && this.CurrentDetail.BreakQty2 > 0) {
      QtyMessage = this.CurrentDetail.BreakQty2 + (this.CurrentDetail.BreakQty3 > 0 ? "-" + (this.CurrentDetail.BreakQty3 - 1).toString() : "+");
    } else if (qtyIndex == 2 && this.CurrentDetail.BreakQty3 > 0) {
      QtyMessage = this.CurrentDetail.BreakQty3 + (this.CurrentDetail.BreakQty4 > 0 ? "-" + (this.CurrentDetail.BreakQty4 - 1).toString() : "+");
    } else if (qtyIndex == 3 && this.CurrentDetail.BreakQty4 > 0) {
      QtyMessage = this.CurrentDetail.BreakQty4 + (this.CurrentDetail.BreakQty5 > 0 ? "-" + (this.CurrentDetail.BreakQty5 - 1).toString() : "+");
    } else if (qtyIndex == 4 && this.CurrentDetail.BreakQty5 > 0) {
      QtyMessage = this.CurrentDetail.BreakQty5 + "+";
    }
    return QtyMessage;
  }

  GetBreakPercString(percIndex: number): string {
    var QtyMessage = "";
    if (percIndex == 0 && this.CurrentDetail.BreakQty1 >= 0) {
      QtyMessage = Math.abs(this.CurrentDetail.BreakPrice1 / 100.0).toString() ;
    } else if (percIndex == 1 && this.CurrentDetail.BreakQty2 >= 0) {
      QtyMessage = Math.abs(this.CurrentDetail.BreakPrice2 / 100.0).toString() ;
    } else if (percIndex == 2 && this.CurrentDetail.BreakQty3 >= 0) {
      QtyMessage = Math.abs(this.CurrentDetail.BreakPrice3 / 100.0).toString() ;
    } else if (percIndex == 3 && this.CurrentDetail.BreakQty4 >= 0) {
      QtyMessage = Math.abs(this.CurrentDetail.BreakPrice4 / 100.0).toString();
    } else if (percIndex == 4 && this.CurrentDetail.BreakQty5 >= 0) {
      QtyMessage = Math.abs(this.CurrentDetail.BreakPrice5 / 100.0).toString();
    }
    return QtyMessage;
  }


  GetAssDetailColumnCount(): number {
    if (this.CurrentDetail.AssemblyDetails != null) {
      if (this.CurrentDetail.AssemblyDetails.length <= 5) {
        return 1;
      }
      else {
        return 2;
      }
    }
    else {
      return 1;
    }
  }

  GetAssDetailWidthClass(): string {
    return "AssDetailWidth" + this.GetAssDetailColumnCount().toString();
  }

  GetAssDetailRowCount(): number {
    if (this.CurrentDetail.AssemblyDetails != null) {
      if (this.CurrentDetail.AssemblyDetails.length > 0) {
        return Math.ceil(this.CurrentDetail.AssemblyDetails.length / this.GetAssDetailColumnCount());
      } else {
        return 0;
      }
    } else {
      return 0;
    }
    
  }

  GetAssDetailContent(row: number,col: number) {
    var startIndex = row + (col * this.GetAssDetailRowCount());

    if (this.CurrentDetail.LineType != "sp") {
      if (startIndex > this.CurrentDetail.AssemblyDetails.length - 1) {
        return "";
      }
      else {
        return this.stripTags(this.CurrentDetail.AssemblyDetails.slice(startIndex, startIndex + 1)[0]);
      }
    }
    else {
      return this.CurrentDetail.AssemblyDetails.length > 0 ?  this.CurrentDetail.AssemblyDetails[0] : "";
    }
  }

  EditAssemblyDetail() {
    //if (this.CurrentDetail.AssemblyDetails[this.CurrentDetail.AssemblyDetails.length - 1] != "") {
    //  this.CurrentDetail.AssemblyDetails.push("");
    //}

    var dialogConfig = {
      width: '50%',
      height: '50%'
    };
    var currentDialog = this.matDialog.open(EditDetailsComponent, dialogConfig);
    
      this.CurrentDetail.AssemblyDetailsDB = this.stripTags(this.CurrentDetail.AssemblyDetails.join("\r\n"));
    
    currentDialog.componentInstance.CurrentDetails = this.stripTags(this.CurrentDetail.AssemblyDetailsDB.replace(/<br \/>/g,"\r\n"));
    currentDialog.componentInstance.SaveDetailsEmitter.subscribe(item => {
      this.CurrentDetail.AssemblyDetailsDB = "<span>" + item.replace(/\r?\n/g, "</span><br /><span>") + "</span>";
      this.CurrentDetail.AssemblyDetails = this.CurrentDetail.AssemblyDetailsDB.split("<br />");
      this.SaveQuoteDetail();
      currentDialog.close();
    });


    currentDialog.componentInstance.CloseEventEmitter.subscribe((event) => {
      currentDialog.close();
    });
  }

  EditProductDetail() {
    var dialogConfig = {
      width: '50%',
      height: '50%'
    };
    var currentDialog = this.matDialog.open(EditDetailsComponent, dialogConfig);
    currentDialog.componentInstance.CurrentDetails = this.CurrentDetail.ProductNotes;
    currentDialog.componentInstance.SaveDetailsEmitter.subscribe(item => {
      this.CurrentDetail.ProductNotes = item;

      this.SaveQuoteDetail();
      currentDialog.close();
    });


    currentDialog.componentInstance.CloseEventEmitter.subscribe((event) => {
      currentDialog.close();
    });
  }

  async AssemblyDetail_Change(ev: any, rowIndex: number, colIndex: number) {
    var startIndex = rowIndex + (colIndex * this.GetAssDetailRowCount());
    this.CurrentDetail.AssemblyDetails[startIndex] = ev.target.value;
    await this.SaveQuoteDetail();
  }

  stripTags(input: string): string {
    return input.replace(/(<([^>]+)>)/gi, "");
  }


  public GetBreakPrice(level: number): string {
    var retString = "";
    switch (level) {
      case 0:
        if (this.CurrentDetail.BreakPrice1 <= 0.0 && this.CurrentDetail.BreakQty1 >= 1 && this.CurrentDetail.ListPrice > 0.0 && this.CurrentDetail.IsV2) {
          retString = (this.CurrentDetail.ListPrice + ((this.CurrentDetail.BreakPrice1 / 100.00) * this.CurrentDetail.ListPrice)).toFixed(2)
        }
        else if (!this.CurrentDetail.IsV2) {
          retString = this.CurrentDetail.UnitPrice1.toFixed(2);
        }
        else {
          retString = "0.0";
        }
        break;
      case 1:
        if (this.CurrentDetail.BreakPrice2 <= 0.0 && this.CurrentDetail.BreakQty2 >= 1 && this.CurrentDetail.ListPrice > 0.0 && this.CurrentDetail.IsV2) {
          retString = (this.CurrentDetail.ListPrice + ((this.CurrentDetail.BreakPrice2 / 100.00) * this.CurrentDetail.ListPrice)).toFixed(2)
        }
        else if (!this.CurrentDetail.IsV2) {
          retString = this.CurrentDetail.UnitPrice2.toFixed(2);
        }
        else {
          retString = "0.0";
        }
        break;
      case 2:
        if (this.CurrentDetail.BreakPrice3 <= 0.0 && this.CurrentDetail.BreakQty3 >= 1 && this.CurrentDetail.ListPrice > 0.0 && this.CurrentDetail.IsV2) {
          retString = (this.CurrentDetail.ListPrice + ((this.CurrentDetail.BreakPrice3 / 100.00) * this.CurrentDetail.ListPrice)).toFixed(2)
        }
        else if (!this.CurrentDetail.IsV2) {
          retString = this.CurrentDetail.UnitPrice3.toFixed(2);
        }
        else {
          retString = "0.0";
        }
        break;
      case 3:
        if (this.CurrentDetail.BreakPrice4 <= 0.0 && this.CurrentDetail.BreakQty4 >= 1 && this.CurrentDetail.ListPrice > 0.0 && this.CurrentDetail.IsV2) {
          retString = (this.CurrentDetail.ListPrice + ((this.CurrentDetail.BreakPrice4 / 100.00) * this.CurrentDetail.ListPrice)).toFixed(2)
        }
        else if (!this.CurrentDetail.IsV2) {
          retString = this.CurrentDetail.UnitPrice4.toFixed(2);
        }
        else {
          retString = "0.0";
        }
        break;
      case 4:
        if (this.CurrentDetail.BreakPrice5 <= 0.0 && this.CurrentDetail.BreakQty5 >= 1 && this.CurrentDetail.ListPrice > 0.0 && this.CurrentDetail.IsV2) {
          retString = (this.CurrentDetail.ListPrice + ((this.CurrentDetail.BreakPrice5 / 100.00) * this.CurrentDetail.ListPrice)).toFixed(2)
        } else if (!this.CurrentDetail.IsV2) {
          retString = this.CurrentDetail.UnitPrice5.toFixed(2);
        }
        else {
          retString = "0.0";
        }
        break;
      default:
        retString = "0.0";
        break;
    }
    return retString;
  }

  async AdjustUnitPrice(ev: any) {
    if (_isNumberValue(ev)) {
      this.CurrentDetail.ListPrice = Number(ev);// Number(ev.replace(/[^0-9.-]/g, ''))
      await this.SaveQuoteDetail();
    }
    
  }

  async AssignBreakQty(ev: any, breakLevel: number) {
    if (breakLevel == 0) {
      this.CurrentDetail.BreakQty1 = Number(ev);
    } else if (breakLevel == 1) {
      this.CurrentDetail.BreakQty2 = Number(ev);
    } else if (breakLevel == 2) {
      this.CurrentDetail.BreakQty3 = Number(ev);
    } else if (breakLevel == 3) {
      this.CurrentDetail.BreakQty4 = Number(ev);
    } else if (breakLevel == 4) {
      this.CurrentDetail.BreakQty5 = Number(ev);
    }

    await this.SaveQuoteDetail();
  }

  async AssignBreakPrice(ev: any, breakLevel: number) {

    var evClean = ev.target.value.replace(/[^\d.]/, "");

    var breakPercent = Math.round(-100.0 * (1.0 - (Number(evClean) / this.CurrentDetail.ListPrice)));
    
    if (breakLevel == 0) {
      this.CurrentDetail.BreakPrice1 = breakPercent;
    } else if (breakLevel == 1) {
      this.CurrentDetail.BreakPrice2 = breakPercent;
    } else if (breakLevel == 2) {
      this.CurrentDetail.BreakPrice3 = breakPercent;
    } else if (breakLevel == 3) {
      this.CurrentDetail.BreakPrice4 = breakPercent;
    } else if (breakLevel == 4) {
      this.CurrentDetail.BreakPrice5 = breakPercent;
    }
    await this.SaveQuoteDetail();
  }

  async AssignBreakPerc(ev: any, breakLevel: number) {
    var evClean = ev.replace(/[^\d.]/, "");

    var breakPercent = -100.0 * (1.0 - (Number(evClean) / this.CurrentDetail.ListPrice));

    if (breakLevel == 0) {
      this.CurrentDetail.BreakPrice1 = -1 *  Number(evClean);
      
    } else if (breakLevel == 1) {
      this.CurrentDetail.BreakPrice2 = -1 * Number(evClean);
    } else if (breakLevel == 2) {
      this.CurrentDetail.BreakPrice3 = -1 *  Number(evClean);
    } else if (breakLevel == 3) {
      this.CurrentDetail.BreakPrice4 = -1 *  Number(evClean);
    } else if (breakLevel == 4) {
      this.CurrentDetail.BreakPrice5 = -1 *  Number(evClean);
    }
    await this.SaveQuoteDetail();
  }

  AddPriceBreak() {
    if (this.CurrentDetail.BreakQty1 <= 0) {
      this.CurrentDetail.BreakQty1 = 1;
    } else if (this.CurrentDetail.BreakQty2 <= 0 || this.CurrentDetail.BreakQty2 == null) {
      this.CurrentDetail.BreakQty2 = this.CurrentDetail.BreakQty1 + 2;
    } else if (this.CurrentDetail.BreakQty3 <= 0 || this.CurrentDetail.BreakQty3 == null) {
      this.CurrentDetail.BreakQty3 = this.CurrentDetail.BreakQty2 + 2;
    } else if (this.CurrentDetail.BreakQty4 <= 0 || this.CurrentDetail.BreakQty4 == null) {
      this.CurrentDetail.BreakQty4 = this.CurrentDetail.BreakQty3 + 2;
    } else if (this.CurrentDetail.BreakQty5 <= 0 || this.CurrentDetail.BreakQty5 == null) {
      this.CurrentDetail.BreakQty5 = this.CurrentDetail.BreakQty4 + 2;
    }

  }

  async DeletePriceBreak(level: number) {
    if (level == 0) {
      this.CurrentDetail.BreakQty1 = 0;
      this.CurrentDetail.BreakPrice1 = 0.0;
    } else if (level == 1) {
      this.CurrentDetail.BreakQty2 = 0;
      this.CurrentDetail.BreakPrice2 = 0.0;
    } else if (level == 2) {
      this.CurrentDetail.BreakQty3 = 0;
      this.CurrentDetail.BreakPrice3 = 0.0;
    } else if (level == 3) {
      this.CurrentDetail.BreakQty4 = 0;
      this.CurrentDetail.BreakPrice4 = 0.0;
    } else if (level == 4) {
      this.CurrentDetail.BreakQty5 = 0;
      this.CurrentDetail.BreakPrice5 = 0.0;
    }
    await this.SaveQuoteDetail();

  }

  ValidateLine():boolean {
    var isValid = true;

    return isValid;
  }

  Reconfigure() {
    this.ReconfigureEmitter.emit(this.CurrentDetail);
  }

  DeleteLine() {
    this.DeleteLineEmitter.emit(this.CurrentDetail);
  }
  
}
